module.exports = __webpack_public_path__ + "static/media/ed96196c-8f03-4a2b-99fb-376d2a54a0a4_1.872dbffde4a9cfef5d6f4e005788ecbd.4c69b7be.jpeg";